<template>
  <div>
    <Header2 />
    <div class="my-container">
      <div class="my-container__nav" v-if="$appTarget !== 'jxt'">
        <ul class="my-container__nav__menu">
          <li
            class="my-container__nav__menu-item"
            v-for="(item, index) in navList"
            :class="{'is-active': activeIndex === index}"
            :key="item.path"
            :index="item.path"
            @click="goto(item.path, index)"
          >
            <i class="iconfont" :class="item.icon"></i>
            <span :class="{'has-unread': item.path === '/my/message' && hasUnRead}">{{item.name}}</span>
          </li>
          <div class="my-container__nav__menu__bar">
            <div
              class="my-container__nav__menu__bar__inner"
              :style="{'transform': barInnerTransform}"
            ></div>
          </div>
        </ul>
      </div>
      <div class="my-container__content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header2 from '@/components/Header/index'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Header2
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  watch: {
    '$route.path': function (val) {
      this.caclActiveIndex(val)
    }
  },
  mounted () {
    this.caclActiveIndex(this.$route.path)
    this.getHasUnReadMessage()
  },
  methods: {
    goto (path, index) {
      this.activeIndex = index
      this.$router.push(path)
    },
    caclActiveIndex (path) {
      this.navList.forEach((item, idx) => {
        if (~path.indexOf(item.keyword)) {
          this.activeIndex = idx
        }
      })
    },
    ...mapActions('message', ['getHasUnReadMessage'])
  },
  computed: {
    navList () {
      const navList = [
        {
          name: '我的贷款',
          path: '/my/loan',
          keyword: 'loan',
          icon: 'iconwodedaikuan'
        },
        {
          name: '企业信息',
          path: '/my/info',
          keyword: 'info',
          icon: 'iconqiyexinxi'
        },
        {
          name: '个人信息',
          path: '/my/info',
          keyword: 'info',
          icon: 'iconqiyexinxi'
        },
        {
          name: '消息中心',
          path: '/my/message',
          keyword: 'message',
          icon: 'iconxiaoxizhongxin'
        }
      ]
      if (this.$store.state.user.userType === '个体工商户') {
        navList.splice(navList.findIndex(item => item.name === '企业信息'), 1)
      } else {
        navList.splice(navList.findIndex(item => item.name === '个人信息'), 1)
      }
      return navList
    },
    barInnerTransform: function () {
      const uiStyle = this.$store.state.user.uiStyle
      let menuItemHeight = uiStyle === 'elder' ? 66 : 52.5
      return `translateY(${this.activeIndex * menuItemHeight}px)`
    },
    ...mapState('message', {
      hasUnRead: state => state.hasUnRead
    }),
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    })
  }
}
</script>

<style lang="scss" scoped>
.my-container {
  @include common-layout;
  display: flex;
  &__nav {
    width: 160px;
    flex-grow: 0;
    &__menu {
      border: none;
      list-style: none;
      padding: 0;
      position: relative;
      &__bar {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 55px;
        &__inner {
          width: 3px;
          height: 18px;
          background: $main-color;
          margin-top: 2px;
          transition: transform 0.2s;
        }
      }
    }

    &__menu-item {
      cursor: pointer;
      margin: 30px 0;
      color: $second-text-color;
      font-size: 17px;
      text-align: left;

      &.is-active {
        color: $main-color;
      }

      & > i {
        margin-right: 5px;
      }

      & > .has-unread {
        position: relative;
        &::after {
          content: "";
          display: block;
          width: 7px;
          height: 7px;
          background: rgba(230, 0, 18, 1);
          border-radius: 50%;
          position: absolute;
          right: -7px;
          top: -3px;
        }
      }
    }
    &__menu-item:hover,
    &__menu-item:focus {
      color: $main-color;
      background: #fff;
    }
  }
  &__content {
    width: 840px;
    flex-grow: 1;
  }
}
</style>
